import { useEffect, useRef, useState } from "react";
import { Tooltip, } from "antd";



interface TruncatedTextProps {
  title: string;
  wrapperClassName?: string;
  textClassName?: string;
  maxLines?: number;
}

const TruncatedText: React.FC<TruncatedTextProps> = ({
  title,
  wrapperClassName = "",
  textClassName = "",
  maxLines = 2,
}) => {
  const textRef = useRef<HTMLDivElement | null>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      const lineHeight = parseFloat(
        window.getComputedStyle(textRef.current).lineHeight
      );
      const maxHeight = lineHeight * maxLines;
      setIsOverflowing(textRef.current.scrollHeight > maxHeight);
    }
  }, [title, maxLines]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (textRef.current && !textRef.current.contains(event.target as Node)) {
        setTooltipVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className={`relative ${wrapperClassName}`}
      onMouseEnter={() => isOverflowing && setTooltipVisible(true)} // Masaüstü hover
      onMouseLeave={() => setTooltipVisible(false)} // Hover çıkınca kapanır
      onTouchStart={(e) => {
        e.stopPropagation();
        if (isOverflowing) setTooltipVisible(true);
      }} // Mobilde uzun basma
    >
      <Tooltip
        title={isOverflowing ? title : ""}
        overlayStyle={{ whiteSpace: "pre-wrap", }}
        open={tooltipVisible}
      >
        <div
          ref={textRef}
          className={`overflow-hidden ${textClassName}`}
          style={{
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: maxLines,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            cursor: isOverflowing ? "pointer" : "default",
          }}
        >
          {title}
        </div>
      </Tooltip>
    </div>
  );
};

export default TruncatedText;
